<script setup>
defineProps({
    label: { type: String, default: '' },
    labelColor: { type: String, default: 'green' },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
})

const dotColors = {
    green:  'bg-green-500',
    blue:   'bg-blue-500',
    purple: 'bg-purple-500',
    red:    'bg-red-500',
    orange: 'bg-orange-400',
}
</script>

<template>
    <div class="flex items-end justify-between gap-6 px-8 pt-6 pb-4 flex-shrink-0">
        <div>
            <div v-if="label" class="flex items-center gap-1.5 mb-1">
                <div class="w-2 h-2 rounded-full flex-shrink-0" :class="dotColors[labelColor] ?? 'bg-green-500'" />
                <span class="text-[11px] font-bold uppercase tracking-widest text-neutral-400 dark:text-neutral-500">{{ label }}</span>
            </div>
            <h1 class="text-[2.75rem] font-black leading-none tracking-tight text-neutral-900 dark:text-white">{{ title }}</h1>
            <p v-if="subtitle" class="text-sm text-neutral-500 dark:text-neutral-400 mt-1.5">{{ subtitle }}</p>
        </div>
        <div class="flex items-center gap-2 pb-1 flex-shrink-0">
            <slot name="actions" />
        </div>
    </div>
</template>
